<template>
  <div id="app">
    <Header @selectvalue="selectLangValue"></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
    <ExternalLink v-if="currentLang=='EN'"></ExternalLink>
  </div>
</template>

<script>
import { menuFixed } from '@/utils/index'

export default {
  name: 'App',
  watch: {
    $route () {
      // this.GoTop()
    }
  },
  data(){
    return {
      menuFixed,
      currentLang:''
    }
  },
  methods: {
    GoTop () {
      (function smoothscroll () {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    getUserData () {
      this.$store.dispatch('user/getUserInfo')
    },
    fixedTop () {

    },
    selectLangValue(val){
      this.currentLang = val
    }
  },
  mounted () {
    this.getUserData()

    setTimeout(() => {
      this.menuFixed()
    }, 100)

    // Meta tags (keywords, description) are now set by router guard in main.js
    // based on route-specific meta fields for proper page-level SEO

    // 动态设置 canonical URL (path-based)
    const currentLang = this.$i18n.locale === 'zn' ? 'cn' : 'en'
    const stripped = this.$route.path.replace(/^\/(en|cn)/, '')
    const pathWithoutLang = (!stripped || stripped === '/') ? '/home' : stripped
    document.querySelector('link[rel="canonical"]').setAttribute('href',
      `https://www.kanglinbio.com/${currentLang}${pathWithoutLang}`)

    // 动态设置 hreflang (path-based)
    document.querySelector('link[hreflang="en"]').setAttribute('href',
      `https://www.kanglinbio.com/en${pathWithoutLang}`)
    document.querySelector('link[hreflang="zh-CN"]').setAttribute('href',
      `https://www.kanglinbio.com/cn${pathWithoutLang}`)
    document.querySelector('link[hreflang="x-default"]').setAttribute('href',
      `https://www.kanglinbio.com/en${pathWithoutLang}`)

      // let lang = localStorage.getItem('lang') || 'CN'
      this.currentLang = localStorage.getItem('lang') || 'CN'
  }
}
</script>

<style lang="less">
@import url('../src/assets/css/media.less');
#app{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue